export function isQueryParamTruthy(param: string, queryRecord: Record<string, string | null | (string | null)[]>) {
  return param in queryRecord && ['', 'true'].some((value) => value === queryRecord[param])
}
